var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jmView"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.fullscreenLoading),expression:"fullscreenLoading"}],staticClass:"jmzbPage"}),_c('SafeDialog',{ref:"myDialog",on:{"onConfirm":_vm.onConfirm,"onClose":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }